module.exports = __webpack_public_path__ + "img/baipei6.8594d6c3.jpg";